import billing_theme from "style/theme_colors";
import styled from "styled-components";

export const ModeloListErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: 28px;
`;

export const DeleteModeloHeader = styled.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  button {
    background-color: transparent;
    border: none;
  }
`;

export const DeleteModeloContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  flex-direction: column;
`;
export const DeleteModeloButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
  gap: 12px;
`;
